export default __webpack_public_path__ + "1a031c019f60868caa61ca67e29d0130.svg";